import type { IBannerProps } from "app/components/React/PlaResearch/InfoBanner";
import { InfoBanner } from "app/components/React/PlaResearch/InfoBanner";

import { useCurrentStateAndParams } from "@uirouter/react";
import type React from "react";

// the InfoBannerContainer helps us to specify when to display the info banner.

interface IBannerContainerProps extends IBannerProps {
    displayInDuration?: string[];
    displayInWebSource?: string[];
    params?: { duration: string; webSource: string };
}

export const InfoBannerContainer: React.FunctionComponent<IBannerContainerProps> = (props) => {
    const { params } = useCurrentStateAndParams();
    const { duration, webSource } = params;
    const { displayInDuration, displayInWebSource } = props;
    const isDurationConditionsSatisfied = displayInDuration?.includes(duration) ?? false;
    const isWebSourceConditionsSatisfied = displayInWebSource?.includes(webSource) ?? false;
    const areAllConditionsSatisfied = isDurationConditionsSatisfied && isWebSourceConditionsSatisfied;
    return areAllConditionsSatisfied ? <InfoBanner {...props} /> : <span />;
};
